
namespace Matrix.Workflow {

    @Serenity.Decorators.registerClass()
    export class ApprovalQueueGrid extends SiteEntityGrid<WorkflowInstanceRow, any> {
        protected getColumnsKey() { return 'Workflow.ApprovalQueue'; }
        protected getIdProperty() { return WorkflowInstanceRow.idProperty; }
        protected getLocalTextPrefix() { return WorkflowInstanceRow.localTextPrefix; }
        protected getService() { return WorkflowInstanceService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        editItem(id) {
            if (!id || (typeof id != "string" && typeof id != "number"))
                return;

            var item = this.view.getItemById(id);
            var dlg = new ApprovalDialog();
            this.initDialog(dlg);
            dlg.execute(Q.toId(id));
        }

        getInitialTitle() {
            return "Approval Queue";
        }

        getButtons() {
            return super.getButtons().filter(x => x.cssClass != "add-button");
        }

        getQuickFilters() {
            var filters = super.getQuickFilters();

            var status = Q.tryFirst(filters, x => x.field == "StatusCode");
            if (status) {
                status.init = (w: ApprovalStatusEditor) => w.value = ApprovalConsts.PendingStatus;
                status.loadState = () => { };
            }

            return filters;
        }

        protected excelExportAction() {
            return "ExcelExport";
        }

        protected onViewSubmit() {
            if (!super.onViewSubmit())
                return false;

            var request = this.view.params as WorkflowInstanceListRequest;
            request.ApprovalQueue = true;

            return true;
        }
    }

    export namespace ApprovalConsts {
        export const PendingStatus = "PENDING";
        export const PendingOperationKey = "$PendingApprovalOperation";
        export const PendingInstanceKey = "$PendingApprovalInstanceId";
        export const DeleteOperation = "DELETE";
        export const InsertOperation = "INSERT";
        export const UpdateOperation = "UPDATE";
        export const ApprovalComment = "ApprovalComment";
        export const ChangeCommentKey = "$ChangeComment";
    }
}